module.exports = __webpack_public_path__ + "static/media/profile.3d48bf6e.png";